import React from 'react';
import { getTokenFromCookie } from '../utils/utils';


export const showDraftsCondition = (prefix) => ['gmina_janowiec'].includes(prefix);

// Attachment objects whose binary data has already been persisted on the
// backend; their data is not re-sent on subsequent (auto)saves.
const savedAttachments = new WeakSet();

const markAttachmentsSaved = (attachments) => {
  (attachments || []).forEach(attachment => {
    if (attachment && typeof attachment === 'object') {
      savedAttachments.add(attachment);
    }
  });
};

export const getDraft = (district, serviceType) => {
  const url = `${process.env.API_URL}/drafts/get?district=${district}&serviceType=${serviceType}`;

  return fetch(url, {
    headers: { Authorization: `Bearer ${getTokenFromCookie()}` },
  })
    .then(response => {
      if (response.status === 404) {
        return null; // draft nie istnieje
      }

      if (!response.ok) {
        throw new Error('Server error');
      }

      return response.json();
    })
    .then(data => {
      if (!data) return null;

      if (data.error) {
        return null;
      }

      const draftData = data.draft.data;
      draftData.attachments = data.draft.attachments;

      // files returned by the backend already exist on disk
      markAttachmentsSaved(draftData.attachments);

      return draftData;
    })
    .catch(() => {
      return null;
    });
};

export const getDraftDataFromState = (state, keys) =>
  Object.fromEntries(keys.map(key => [key, state[key]]));

let timeout = null;

export const saveDraft = async (
  draft,
  district,
  serviceType,
  { debounce = true, delay = 1000 } = {}
) => {

  if (debounce) {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      performSave(draft, district, serviceType);
    }, delay);

    return;
  }

  // zapis natychmiastowy
  clearTimeout(timeout);

  return performSave(draft, district, serviceType);
};

const performSave = (draft, district, serviceType) => {

  const url = `${process.env.API_URL}/drafts/save`;

  // strip binary data of attachments already persisted on the backend
  let draftToSend = draft;
  if (draft.attachments) {
    draftToSend = {
      ...draft,
      attachments: draft.attachments.map(attachment => (
        savedAttachments.has(attachment) ? { ...attachment, data: null } : attachment
      )),
    };
  }

  const payload = {
    draft: draftToSend,
    district,
    serviceType
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getTokenFromCookie()}`,
    },
    body: JSON.stringify(payload)
  })
  .then(response => response.json())
  .then(data => {
    if (!data.error) {
      markAttachmentsSaved(draft.attachments);
      window.dispatchEvent(
        new CustomEvent("draft:saved")
      );
    }
  })
  .catch(() => {
    window.dispatchEvent(
      new CustomEvent("draft:error")
    );
  });
};

export const areEqual = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
};

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  color: 'black',
  background: '#a9d8ea',
};

const mobileBtnStyle = {
  ...btnStyle,
  width: '100%',
  marginRight: '0',
  marginBottom: '10px',
};

export const renderSaveDraftButton = (clickMethod, mobile=false) => (
  <button
    type="submit-lg"
    className={`btn btn-primary ${mobile ? "mobile-button" : ""}`}
    style={btnStyle}
    onClick={clickMethod}
    title='Zapisz wersję roboczą'
    >
      Zapisz
  </button>
)



// WEBPACK FOOTER //
// src/components/DraftManagement/draftManager.js